'use client';

import type { ButtonHTMLAttributes } from 'react';
import { twMerge as tw } from 'tailwind-merge';

interface ButtonPrimaryProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
}

const ButtonPrimary = ({ type = 'button', className, disabled = false, children, ...props }: ButtonPrimaryProps) => {
  return (
    <button
      type={type}
      className={tw(
        'inline-flex items-center justify-center bg-primary-dark dark:bg-primary-dark font-semibold py-3.5 px-7 rounded-xl transition-all duration-300 no-underline shadow-md relative overflow-hidden z-10 tracking-wide hover:bg-primary-dark dark:hover:bg-primary hover:-translate-y-1 hover:shadow-lg active:-translate-y-px text-shadow-gray-950 text-shadow-lg/70 *:drop-shadow-md *:drop-shadow-black/70',
        'text-white text-[#ffffff] font-bold', // Keep the working approach with improved weight
        'border-2 border-primary dark:border-primary-light', // Add border with original primary color
        className,
      )}
      disabled={disabled}
      aria-disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default ButtonPrimary;
